import React from "react";
import { LoginRedirect } from "../components/AuthGate";

// Dashboard
import WindProjects from "../pages/Projects";
import WindProject from "../pages/Project";
import LandOwners from "../pages/Owners";
import Properties from "../pages/Properties";
import Screening from "../pages/Screening";
import Sandbox from "../pages/Sandbox";
import SandboxMap from "../pages/SandboxMap";
import ProjectOwners from "../pages/ProjectOwners";
import Forbidden from "../pages/Forbidden";
import Metrics from "../pages/Metrics";



const protectedRoutes = [
  { path: "pages/owners/project/:id", element: <ProjectOwners /> },
  { path: "pages/project/:id", element: <WindProject /> },
  { path: "pages/projects", element: <WindProjects /> },
  { path: "pages/owners", element: <LandOwners /> },
  { path: "pages/properties", element: <Properties /> },
  { path: "pages/screening", element: <Screening /> },
  { path: "pages/sandbox/:id", element: <SandboxMap /> },
  { path: "pages/sandbox", element: <Sandbox /> },
  { path: "pages/metrics/:country", element: <Metrics /> },
  { path: "pages/metrics", element: <Metrics /> },
  { path: "login", element: <LoginRedirect />  },
  { path: "forbidden", element: <Forbidden />  }

]


export default protectedRoutes;
	
	